import { z } from 'zod'

import { formatToNumber } from '@/lib/utils'

export const FormCreatePriceListProductInLineSchema = z.object({
  produto: z.string().min(1, 'Produto obrigatório'),
  categoria: z.string().optional(),
  imagem: z.string().optional(),
  valor: z
    .string()
    .min(1, 'Valor obrigatório')
    .refine((val) => Number(formatToNumber(val)) > 0, {
      message: 'Valor obrigatório',
    }),
})

export type FormCreatePriceListProductInLine = z.infer<
  typeof FormCreatePriceListProductInLineSchema
>
